import React from 'react';
import cl from './Header.module.css';
import { NavLink } from 'react-router-dom';
import { useState } from 'react';

const Header = (props) => {
  const [mobileMenu, setMobileMenu] = useState(cl.mobile_header_links_hidden);
  const [mobileMenuIcon, setMobileMenuIcon] = useState(cl.mobile_menu_icon);
  const [mobileCloseIcon, setMobileCloseIcon] = useState(
    cl.mobile_close_icon_hidden
  );
  let onMenuClick = () => {
    setMobileMenu(cl.mobile_header_links);
    setMobileMenuIcon(cl.mobile_menu_icon_hidden);
    setMobileCloseIcon(cl.mobile_close_icon);
  };
  let onCloseClick = () => {
    setMobileMenu(cl.mobile_header_links_hidden);
    setMobileMenuIcon(cl.mobile_menu_icon);
    setMobileCloseIcon(cl.mobile_close_icon_hidden);
  };
  let onSearchChange = (e) => {
    let text = e.target.value;
    props.updateNewSearchText(text);
  };
  let onSearchClick = () => {
    console.log(props.productsPage.newSearchText);
  };

  return (
    <section className={cl.container}>
      <div className={cl.middle_line}>
        <div className={cl.middle_line_logo}>
          <h1>{props.aboutData.shopName}</h1>
        </div>
        <div className={cl.search_bar}>
          <input type="text" value={props.productsPage.newSearchText} onChange={onSearchChange} placeholder="Search"></input>
          <NavLink to="search">
            <button className={cl.search_bar_button} onClick={onSearchClick}>
              <svg
                className={cl.search_bar_button_svg}
                height="50px"
                viewBox="0 0 50 50"
                width="50px"
              >
                <rect fill="none" />
                <circle
                  cx="21"
                  cy="20"
                  fill="none"
                  r="16"
                  stroke="#000000"
                  strokeLinecap="round"
                  strokeMiterlimit="10"
                  strokeWidth="2"
                />
                <line
                  fill="none"
                  stroke="#000000"
                  strokeMiterlimit="10"
                  strokeWidth="4"
                  x1="32.229"
                  x2="45.5"
                  y1="32.229"
                  y2="45.5"
                />
              </svg>
            </button>
          </NavLink>
        </div>
        <NavLink
          className={(headerData) =>
            headerData.isActive
              ? cl.header_link_active_cart
              : cl.header_link_cart
          }
          to="/cart"
        >
          <div className={cl.cart_items}>
            <svg version="1.1" viewBox="0 0 24 24"><g id="info"/><g id="icons"><g id="cart"><path d="M20,13H4c-0.7,0-1.1,0.6-1,1.2l1.4,6.2c0.2,0.9,1,1.6,2,1.6h11.1c1,0,1.8-0.7,2-1.6l1.4-6.2C21.1,13.6,20.6,13,20,13z     M11,18c0,0.5-0.4,1-1,1s-1-0.5-1-1v-2c0-0.5,0.4-1,1-1s1,0.5,1,1V18z M15,18c0,0.5-0.4,1-1,1s-1-0.5-1-1v-2c0-0.5,0.4-1,1-1    s1,0.5,1,1V18z"/><path d="M21,8h-2.2l-1.9-4.8c-0.4-1-1.6-1.5-2.6-1.1c-1,0.4-1.5,1.6-1.1,2.6L14.5,8H9.5l1.3-3.3c0.4-1-0.1-2.2-1.1-2.6    c-1-0.4-2.2,0.1-2.6,1.1L5.2,8H3c-1.1,0-2,0.9-2,2v1c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1v-1C23,8.9,22.1,8,21,8z"/></g></g></svg>
            <p className={cl.cart_items_number}>{props.cartItems.length}</p>
          </div>
        </NavLink>
        <svg onClick={onMenuClick} className={mobileMenuIcon} height="30px" viewBox="0 0 512 512">
          <title />
          <g data-name="1" id="_1">
            <path d="M441.13,166.52h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
            <path d="M441.13,279.72h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
            <path d="M441.13,392.92h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
          </g>
        </svg>
        <svg
          onClick={onCloseClick} className={mobileCloseIcon} height="24px" viewBox="0 0 32 32" width="24px">
          <g>
            <polyline fill="none" points="   649,137.999 675,137.999 675,155.999 661,155.999  " stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2"/>
            <polyline fill="none" points="   653,155.999 649,155.999 649,141.999  " stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2"/>
            <polyline fill="none" points="   661,156 653,162 653,156  " stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="2"/>
          </g>
          <g>
            <path d="M11.312,12.766c0.194,0.195,0.449,0.292,0.704,0.292c0.255,0,0.51-0.097,0.704-0.292c0.389-0.389,0.389-1.02,0-1.409   L4.755,3.384c-0.389-0.389-1.019-0.389-1.408,0s-0.389,1.02,0,1.409L11.312,12.766z" />
            <path d="M17.407,16.048L28.652,4.793c0.389-0.389,0.389-1.02,0-1.409c-0.389-0.389-1.019-0.561-1.408-0.171L15.296,15   c0,0-0.296,0-0.296,0s0,0.345,0,0.345L3.2,27.303c-0.389,0.389-0.315,1.02,0.073,1.409c0.194,0.195,0.486,0.292,0.741,0.292   s0.528-0.097,0.722-0.292L15.99,17.458l11.249,11.255c0.194,0.195,0.452,0.292,0.706,0.292s0.511-0.097,0.705-0.292   c0.389-0.389,0.39-1.02,0.001-1.409L17.407,16.048z" />
          </g>
        </svg>
        <div className={mobileMenu}>
          <NavLink className={cl.mobile_link} to="/">
            Home
          </NavLink>
          <NavLink className={cl.mobile_link} to="/about">
            About
          </NavLink>
          {/* <NavLink className = {cl.mobile_link} to='/news'>News</NavLink> */}
          <NavLink className={cl.mobile_link} to="/products">
            Products
          </NavLink>
          <NavLink className={cl.mobile_link} to="/contacts">
            Contacts
          </NavLink>
          <NavLink className={cl.mobile_link} to="/policy">
            Policy
          </NavLink>
        </div>
        
        
      </div>
      <div className={cl.bottom_line}>
        <div className={cl.bottom_line_links}>
          <NavLink
            className={(headerData) =>
              headerData.isActive ? cl.header_link_active : cl.header_link
            }
            to=""
          >
            Home
          </NavLink>
          <NavLink
            className={(headerData) =>
              headerData.isActive ? cl.header_link_active : cl.header_link
            }
            to="/about"
          >
            About
          </NavLink>
          {/* <NavLink
            className={(headerData) =>
              headerData.isActive ? cl.header_link_active : cl.header_link
            }
            to="/news"
          >
            News
          </NavLink> */}
          <NavLink
            className={(headerData) =>
              headerData.isActive ? cl.header_link_active : cl.header_link
            }
            to="/products"
          >
            Products
          </NavLink>
          <NavLink
            className={(headerData) =>
              headerData.isActive ? cl.header_link_active : cl.header_link
            }
            to="/contacts"
          >
            Contacts
          </NavLink>
          <NavLink
            className={(headerData) =>
              headerData.isActive ? cl.header_link_active : cl.header_link
            }
            to="/policy"
          >
            Policy
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default Header;
